<div class="yesNoOption">
	<ng-container *ngTemplateOutlet="yesScoreTemplate" />

	<sim-slide-toggle-if-else
		[disabled]="disabled || mode !== AssessablePanelMode.Answer"
		[checked]="answer"
		[enableUntouchedState]="true"
		(checkedEmitter)="onUpdateAnswerSimple.emit($event)"
	>
		<ng-container first-option>
			{{ T.SHARED_EXPANSION_NO | translate }}
		</ng-container>
		<ng-container second-option>
			{{ T.SHARED_EXPANSION_YES | translate }}
		</ng-container>
	</sim-slide-toggle-if-else>

	<ng-container *ngTemplateOutlet="noScoreTemplate" />
</div>
